// src/utils/formatTime.js

// Convierte segundos a "mm:ss"
// Convierte segundos a "mm:ss" con redondeo
export const formatTimeFromSeconds = (seconds) => {
  if (!seconds || isNaN(seconds)) return "00:00";
  const rounded = Math.round(seconds); // ✅ redondea correctamente
  const minutes = Math.floor(rounded / 60);
  const secs = rounded % 60;
  return `${minutes}:${secs.toString().padStart(2, '0')}`;
};


// Convierte "mm:ss" a segundos
export const parseTime = (time) => {
  const [minutes, seconds] = time.split(":").map(Number);
  return minutes * 60 + seconds;
};

// Convierte segundos a "hh:mm:ss"
export const formatDuration = (seconds) => {
  if (!seconds) return "00:00:00"; // Si no hay valor, retorna un formato vacío
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  return `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
};

// Convierte "hh:mm:ss" a segundos
export const parseDuration = (time) => {
  const [hrs, mins, secs] = time.split(":").map(Number);
  return (hrs * 3600) + (mins * 60) + secs;
};
